import { globalEnvironment } from '../../../../environments/environment.prod';
import { BaseApplication, BaseApplicationLogo, medicalTag } from 'base';

export const environment = {
  global: globalEnvironment,
  env: 'prod',
  application: {
    project: 'Stazzle medical',
    app: BaseApplication.medical,
    tag: medicalTag,
    logo: BaseApplicationLogo.medical,
    logoSmall: BaseApplicationLogo.medicalSmall,
    logoSystemPage: BaseApplicationLogo.systemPage,
    logoSystemPageSmall: BaseApplicationLogo.systemPageSmall,
  },
};
